import { createContext, useContext } from '@berlin-front/common/composables/context';
import { onBeforeUnmount } from '@vue/composition-api';
import { MemberRequestContext } from './MemberRequestContext';

/**
 * まとめ払いにおける会員登録フローの出入りを検出してフォームデータ他を設定する。
 */
export const AtoneNPMemberRegisterGroupContext = createContext(() => {
  const req = useContext(MemberRequestContext);

  // ログイン・登録フローが切り替わるたびにフォーム内のpaswordはクリアする。
  req.registerMemberFormState.password = '';

  // NP会員ルートではメールアドレスの変更できない。
  req.isEmailEditable.value = false;

  // NP会員からの変更ルートは8
  req.memberRegistrationRoute.value = 8;

  onBeforeUnmount(() => {
    // ログイン・登録フローが切り替わるたびにフォーム内のpaswordはクリアする。
    req.registerMemberFormState.password = '';
  });

  return {};
}, 'NPMemberRegisterContext');
